import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './ThanksBlock.css';

const ThanksBlock = ({ ClassName }) =>
  <div className={cx(s.thanksBlock, { [ClassName]: !!ClassName })}>
    <h2>
      <FormattedMessage id="Спасибо!" />
    </h2>
    <p>
      <FormattedMessage id="Ваша заявка отправлена!" />
    </p>
    <p>
      <FormattedMessage id="В ближайшее время с вами свяжется менеджер автосалона" />
    </p>
  </div>;

ThanksBlock.propTypes = {
  ClassName: PropTypes.string,
};

ThanksBlock.defaultProps = {
  ClassName: '',
};

export default withStyles(s)(ThanksBlock);



// WEBPACK FOOTER //
// ./src/shared/components/DealerServiceForm/ThanksBlock.js